import { ReactNode } from 'react';
import styles from './FancyPanel.module.css';

type Props = {
  children: ReactNode;
};

export function FancyPanelActionGroup({ children }: Props) {
  return (
    <div className={styles.actionGroup}>
      { children }
    </div>
  );
}
